import { FC } from 'react';
import Form from '../../../../components/common/Forms/Form';
import { SchoolInformationFields, normalizeInitialValues } from '../../../../config/tuitionMangerViewDetailsFields';
 
interface SchoolInformationProps {
  applicationData?: any;
}
 
const SchoolInformation: FC<SchoolInformationProps> = ({ applicationData }) => {
  const schoolInfo = applicationData?.schoolInfo || {};
 
  const mappedSchoolInfo = {
    ...schoolInfo,
    degreeCompletionYear:
      schoolInfo?.degreeCompletionYear === "-100" ? 'Non Degree Program' : schoolInfo?.degreeCompletionYear,
  };
 
  return (
    <div>
      <h2 className="h3">School information</h2>
      <Form
        fields={SchoolInformationFields}
        initialValues={normalizeInitialValues(mappedSchoolInfo, SchoolInformationFields)}
        isViewDetails
        buttons={[]}
        className="mt-4"
      />
    </div>
  );
};
 
export default SchoolInformation;